<app-main-contents>
  <app-title [title]="title"></app-title>
  <app-sending *ngIf="sending"></app-sending>
  <app-progress *ngIf="loading"></app-progress>

  <div class="h-margin--b12">
    <app-select [options]="yearOptions" [(ngModel)]="selectedFilter" (change)="onFilterChange()"></app-select>
  </div>

  <div class="master-info-link-wrap">
    <a class="master-info-link" (click)="openInfoDialog()">口座振替日マスタについて</a>
  </div>

  <app-action-grid
    [data]="rows"
    [loading]="loading"
    [rowSelection]="rowSelection"
    [columns]="columns"
    minusHeight="95"
    [actionButtons]="actionButtons"
    (actionCommit)="onActionCommit($event)"
  ></app-action-grid>
</app-main-contents>

<app-dialog
  *ngIf="addDialogOpen"
  [title]="'マスタ追加'"
  commitButtonText="登録"
  (commit)="commitAddDialog()"
  (cancel)="closeAddDialog()"
>
  <div class="table-wrap add-dialog-table" *ngIf="addDialogRows.length">
    <table>
      <thead>
        <tr>
          <th class="index">No</th>
          <th>年月</th>
          <th>実振替日</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of addDialogRows; let i = index">
          <td class="index">{{ i + 1 }}</td>
          <td>
            <span>{{ toYearMonthLabel(row.tranDate) }}</span>
          </td>
          <td>
            <input type="date" [(ngModel)]="row.actTranDate" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</app-dialog>

<app-dialog
  *ngIf="infoDialogOpen"
  [title]="'口座振替日マスタについて'"
  widthSize="large"
  [hideCommitButton]="true"
  cancelButtonText="閉じる"
  (cancel)="closeInfoDialog()"
>
  <div class="master-info-section-title">■前提</div>
  <ul class="master-info-bullet-list">
    <li>【実振替日】とは、請求書に「口座振替日」として印字され、お客様の口座から実際に代金が引き落とされる日のこと</li>
    <li>原則は「月末」だが、金融機関の休業日の場合は「翌営業日」となる</li>
    <li>毎年、三菱UFJファクター社の公式サイトにて1年分のスケジュールが公開される</li>
    <li>実振替日はAPIで取得できるが、タイミングが請求書の発行に間に合わないため、本画面から手動で登録する必要がある</li>
  </ul>

  <div class="master-info-section-title">■やること(年1回)</div>
  <ol class="master-info-list">
    <li>
      ①<a href="https://www.muf.bk.mufg.jp/collect/member/wide/" target="_blank" rel="noopener noreferrer" class="master-info-link"
        >三菱UFJファクター社のサイト</a
      >の「■20XX年スケジュール表」の中から「月末日振替用」のPDFを取得<br />
      
    </li>
    <li>②各月に対応する実振替日(PDF参照)を登録</li>
  </ol>
</app-dialog>
